import React from "react";
import "../styles/Footer.css";
import { FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaPhone, FaLocationDot, FaXTwitter } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import playstore from "../Assests/Images/playstore.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Company Info */}
        <div className="footer-column" style={{ marginLeft: "20px" }}>
          <h3>CityZoom</h3>
          <h4 style={{ color: "white", textAlign:"justify" }}>
            Your go-to platform for all the Jobs,Events, Services, Offers,
            Classifieds, and Sponsored ads. 
            Find all the opportunities in one place at your City now.
          </h4>
        </div>

        {/* Column 2: Quick Links (Vertical) */}
        <div className="footer-column">
          <h3>Quick Links</h3>
          <div className="quick-links-vertical">
            <a href="/">Home</a>
            <a href="/#about">About</a>
            <a href="/#explore">Explore</a>
            <a href="/#contact">Contact</a>
          </div>
        </div>

        {/* Column 3: Play Store */}
        <div className="footer-column" style={{marginLeft:"-90px"}}>
          <h3>Get It On</h3>
          <div className="playstore-container">
            <img
              src={playstore}
              alt="Get it on Playstore"
              className="playstore-image"
            />
          </div>
        </div>

        {/* Column 4: Social Media */}
        <div className="footer-column">
          <h3>Follow Us On</h3>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaXTwitter />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Column 5: Contact Info */}
        <div className="footer-column">
          <h3>Contact Info</h3>
          <ul>
            <li>
              <FaPhone /> <a href="tel:+91 9550768953">+91 9550768953</a>
            </li>
            <li>
              <IoMdMail /> <a href="mailto:contact@cityzoom.in">contact@cityzoom.in</a>
            </li>
            <li>
              <FaLocationDot />{" "}
              <a href="">Bhoomatha Thalluri Heights, Kankipadu, Vijayawada-521151</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <hr
        style={{
          borderColor: "black",
          margin: "20px auto",
          width: "90%",
        }}
      />

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p style={{ margin: 0 }}>© 2025 CityZoom. All rights reserved.</p>
        <p style={{ margin: 0 }}>
          Powered by{" "}
          <a
            href="https://evolvexinnovations.com/"
            target="_blank"
            className="secondary-color-link"
            style={{ color: "black", fontWeight: "bold" }}
          >
            Evolve X Innovations
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
